module.exports = __webpack_public_path__ + "static/media/ISO23601.c6ccb05a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/wbstdt/imgs/normes/ISO23601.svg
// module id = 72
// module chunks = 0